<div class="pb-3">
    <app-card-table
        [tableTitle]="'service.logs.title'"
        [gridData]="store.data.getAuditLogs()"
        [columns]="columns"
        translatePrefix="entities.history."
        [hideCheckboxes]="true"
        [additionalFilter]="filters()"
        [refreshCallback]="store.api.getAuditLogs"
        [rowExpansion]="rowExpansion"
    >
        <ng-template pTemplate="time" let-item="item">
            {{ item.timestamp | localDate: 'HH:mm:ss' }}
        </ng-template>

        <ng-template pTemplate="data" let-item="item">
            {{ item | getEntityDataSummary }}
        </ng-template>

        <ng-template #rowExpansion let-item="item">
            @if (store.history(); as data) {
                @if (item.action !== 'read') {
                    <div class="flex gap-3 align-items-center">
                        <div class="flex gap-2 align-items-center">
                            <i class="pi pi-circle-fill text-success"></i>
                            <span>{{ 'entities.history.legend.created' | translate }}</span>
                        </div>
                        <div class="flex gap-2 align-items-center">
                            <i class="pi pi-circle-fill text-primary"></i>
                            <span>{{ 'entities.history.legend.updated' | translate }}</span>
                        </div>
                        <div class="flex gap-2 align-items-center">
                            <i class="pi pi-circle-fill text-danger"></i>
                            <span>{{ 'entities.history.legend.deleted' | translate }}</span>
                        </div>
                    </div>
                }
                <app-audit-log-tree-v2
                    [tree]="data[item.id]"
                    [action]="item.action"
                ></app-audit-log-tree-v2>
            }
        </ng-template>
    </app-card-table>
</div>
